import { use } from 'react';
import TunnelContext from '../tunnel.context';
const useTunnelBookingType = () => {
    const { bookingType } = use(TunnelContext);
    return bookingType;
};
export default useTunnelBookingType;
